<template>
  <router-link class="info-tooltip" v-b-tooltip.click.right :title="text">
    <font-awesome-icon :icon="icon" size="sm" class="info-tooltip"/>
  </router-link>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faInfoCircle)

/**
 * Small convenience component for displaying tooltips linked with an 'info' icon
 */
export default {
  name: 'InfoTooltip',
  props: {
    text: String,
    icon: {
      type: Array,
      default: function () {
        return ['fa', 'info-circle']
      }
    }
  }
}
</script>

<style>
  .info-tooltip {
  }
</style>
